import { useContext } from 'react';
import CompositionAdvancedOptions from '../components/composition-advanced-options/CompositionAdvancedOptions';
import styles from './CompositionsView.module.css';
import ThemeContext from 'config/context/themeContext';
import EditableCompositionTable from '../components/editable-composition-table/EditableCompositionTable';
import CompositionStructureView from '../components/composition-structure-view/CompositionStructureView';
import { CompositionAdvancedOptionsContextProvider, useCompositionAdvancedOptionsContext } from '../context/CompositionAdvancedOptionsContext';

const CompositionsViewInner = () => {
    const { dark } = useContext(ThemeContext);
    const { viewType } = useCompositionAdvancedOptionsContext();
    return (
        <div className={`${styles.compositions_view} ${dark ? styles.dark : ""}`}>
            <CompositionAdvancedOptions />
            <div style={{ display: viewType === 'structure' ? 'grid' : 'none' }}>
                <CompositionStructureView />
            </div>
            <div style={{ display: viewType === 'browse' ? 'grid' : 'none' }}>
                <EditableCompositionTable />
            </div>
        </div>
    )
}

const CompositionsView = () => (
    <CompositionAdvancedOptionsContextProvider>
        <CompositionsViewInner />
    </CompositionAdvancedOptionsContextProvider>
)

export default CompositionsView;